import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Range } from 'slate';
import { document } from '../../helpers/BrowserHelpers';
import FileBlockComponent from './FileBlock';
import BlockTypes from '../../types/BlockTypes';
import renderBlocks from '../utils/renderBlocks';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import makeToolbarButton, { BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import { AttachmentIcon } from '../../components/Icons';
import serializers from './serializers';
import FileHelpers from '../../helpers/FileHelpers';
import { getEventTransfer } from 'slate-react';
import isPasteFromMSWord from '../ClipboardPlugin/utils/isPasteFromMSWord';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.FILE, {
    isVoid: true
  })
};

function getBlockTypeFromExtension(extension) {
  if (FileHelpers.isImageExtension(extension)) {
    return BlockTypes.IMAGE;
  } else if (FileHelpers.isPDFExtension(extension)) {
    return BlockTypes.PDF;
  } else {
    return BlockTypes.FILE;
  }
}

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator,
      _ref$getUser = _ref.getUser,
      getUser = _ref$getUser === void 0 ? function (userId) {} : _ref$getUser,
      _ref$addMediaFileToNo = _ref.addMediaFileToNote,
      addMediaFileToNote = _ref$addMediaFileToNo === void 0 ? function (x) {
    return x;
  } : _ref$addMediaFileToNo;

  var Component = decorator(FileBlockComponent);
  return [normalizeNode(BlockTypes.EMBED, [shouldBeAtRoot]), {
    commands: {
      openFileUpload: function openFileUpload(editor) {
        var accept = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', accept);

        input.onchange = function () {
          if (!editor.value.startBlock) return;
          addMediaFileToNote({
            file: input.files[0],
            meta: {
              blockKey: editor.value.startBlock.key
            }
          });
        };

        input.click();
      },
      addFilesBeforeNode: function addFilesBeforeNode(editor, files, node) {
        var nodeBefore = editor.value.document.getPreviousSibling(node.key);
        addMediaFileToNote({
          file: files[0],
          meta: {
            blockKey: nodeBefore ? nodeBefore.key : node.key
          }
        });
        return editor;
      },
      insertUploadedFile: function insertUploadedFile(editor, key, rawData, type) {
        var url = rawData.url,
            _rawData$mediaMeta = rawData.mediaMeta,
            data = _rawData$mediaMeta === void 0 ? {} : _rawData$mediaMeta;
        var filename = data.name;
        var node = editor.value.document.getNode(key);
        if (!node) return false;
        var extension = FileHelpers.getExtensionFromURL(filename);
        var blockType = type || getBlockTypeFromExtension(extension);
        var range = Range.create().moveToEndOfNode(node).normalize(editor.value.document);
        return editor.insertBlockAtRange(range, {
          type: blockType,
          data: _objectSpread({
            url: url
          }, data),
          isVoid: true
        });
      }
    }
  }, {
    serializers: serializers,
    schema: schema,
    onPaste: function onPaste(event, editor, next) {
      var transfer = getEventTransfer(event);

      if (transfer.type === 'files' && !isPasteFromMSWord(transfer)) {
        event.preventDefault();
        event.stopPropagation();
        var focusBlock = editor.value.focusBlock;
        return addMediaFileToNote({
          file: transfer.files[0],
          meta: {
            blockKey: focusBlock.key
          }
        });
      }

      return next();
    }
  }, renderBlocks(_defineProperty({}, BlockTypes.FILE, function (props) {
    return React.createElement(Component, Object.assign({}, props, {
      getUser: getUser
    }));
  })), makeToolbarButton(BlockTypes.FILE, {
    icon: AttachmentIcon,
    title: 'File',
    tip: 'Max file size: 200MB',
    visibility: BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    onApply: function onApply(editor) {
      return editor.openFileUpload();
    }
  })];
});